import React, { useState} from "react";
import './Header.css';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';



const Header = () => {

    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };


    const navigate = useNavigate();
    const handleNavigationHome = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('hero');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
        setIsNavOpen(!isNavOpen);
      }

      const handleNavigationAbout = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('about');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
        setIsNavOpen(!isNavOpen);
      }

    const handleNavigationContact = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('contact');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
        setIsNavOpen(!isNavOpen);
      }

      const handleNavigationServices = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('services');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
        setIsNavOpen(!isNavOpen);
      }


    return (
        <header className="header">
          <div className="company-details" id="company-details">
              <div className="logo2">
                  <img src={require("../assets/images/delta-ohne.png")} width={150} height={120}></img>
              </div>
              <div className="company-name" id="company-name">
                  Delta Tank GmbH
              </div>
            </div>
            <button className="hamburger" onClick={toggleNav}>
                ☰
            </button>
            <nav className={`nav ${isNavOpen ? 'nav-open' : ''}`}>
                <ul className="nav-list">
                    <li className="nav-item" onClick={handleNavigationHome}><Link to="/" className='header-link'><a href="">Home</a></Link></li>
                    <li className="nav-item" onClick={handleNavigationAbout}><Link to="/" className='header-link' reloadDocument ><a href="#about">Über Uns</a></Link></li>
                    <li className="nav-item" onClick={handleNavigationServices}><Link to="/#services" className='header-link' reloadDocument><a href="#services">Dienstleistungen</a></Link></li>
                    <li className="nav-item" onClick={handleNavigationContact}><Link to="/#contact" className='header-link' reloadDocument><a href="#contact">Kontakt</a></Link></li>
                </ul>
            </nav>
    </header>
    );
}

export default Header;